import HomeComp from '../components/homeComp';

const Home = () => {
    return <HomeComp />;
};
export default Home;
